import { render, staticRenderFns } from "./upgrade-now-page.vue?vue&type=template&id=409a2e2c&scoped=true"
import script from "./upgrade-now-page.vue?vue&type=script&lang=js"
export * from "./upgrade-now-page.vue?vue&type=script&lang=js"
import style0 from "./upgrade-now-page.vue?vue&type=style&index=0&id=409a2e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409a2e2c",
  null
  
)

export default component.exports